import ApolloClient from "apollo-boost";

const apolloClient = new ApolloClient({
  // eslint-disable-next-line no-undef
  uri: process.env.VUE_APP_GMOV_GRAPHQL_URL,
  request: (operation) => {
    const token = localStorage.getItem('token')
    operation.setContext({
      headers: {
        authorization: token ? `${token}` : ''
      }
    })
  }
})

export default apolloClient
